export default __webpack_public_path__ + "static/media/calendar.ce348ee0.png";